<div mat-dialog-content>
  <div class="text-center">
    <div class="i-circle warning">
      <i class="fas fa-exclamation-triangle"></i>
    </div>
    <h4 class="message-text color-default" [innerHTML]="message | translate"></h4>
    <p></p>
  </div>
</div>
<div mat-dialog-actions>
  <div class="full-width text-right" *ngIf="buttonType === 1">
    <button type="button" class="btn btn-warning" title="{{'OK' | translate}}" (click)="dialogRef.close(null)">
      {{'OK' | translate}}
    </button>
  </div>

  <div class="full-width text-right" *ngIf="buttonType === 2">
    <button type="button" class="btn btn-default" title="{{'BUTTON.CANCEL' | translate}}"
      (click)="dialogRef.close(false)">
      <i class="fas fa-ban"></i>&nbsp;{{'BUTTON.CANCEL' | translate}}
    </button>
    <button type="button" class="btn btn-warning" title="{{'BUTTON.CONFIRM' | translate}}"
      (click)="dialogRef.close(true)">
      <i class="fas fa-check"></i>&nbsp;{{'BUTTON.CONFIRM' | translate}}
    </button>
  </div>
</div>